import { createSlice, current } from '@reduxjs/toolkit';
import { LOADING_STATUS } from '@sonifi/wb-core/common/Constants';

const initialState = {
  formValues: {},
  status: LOADING_STATUS.notLoading,
};

export const selfServiceSlice = createSlice({
  name: 'selfService',
  initialState,
  reducers: {
    setConfig: (state, action) => {
      const { formValues } = current(state);
      state.formValues = { ...formValues, ...action.payload };
    },
    setStatus: (state, action) => {
      state.status = action.payload;
    },
    cleanSelfServiceSlice() {
      return initialState;
    },
  },
});

export const { cleanSelfServiceSlice, setConfig, setStatus } = selfServiceSlice.actions;

export default selfServiceSlice.reducer;
